import React from "react";
import ReactDOM from "react-dom";

import MiddleMan from './components/MiddleMan';
import BottomHero from './components/BottomHero';
import './web.css';
import './web_resp.css';

function App(){
    return (
        <React.Fragment>
            <MiddleMan />
            <BottomHero />
        </React.Fragment>
    );
}

ReactDOM.render( <App />, document.querySelector(".container"));